<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
  <div *ngIf="isLoading" class="flex justify-center items-center py-20">
    <div class="animate-spin rounded-full h-12 w-12 border-2 border-border border-t-primary shadow-[0_0_15px_var(--color-primary-glow)]"></div>
  </div>

  <div
    *ngIf="!isLoading && errorMessage"
    class="surface-elevated border border-danger/30 rounded-xl p-8 text-center bg-danger/5 backdrop-blur-sm relative overflow-hidden"
  >
    <div class="absolute inset-0 bg-gradient-to-b from-danger/10 to-transparent opacity-50"></div>
    <div class="relative z-10">
      <i class="fa-solid fa-triangle-exclamation text-4xl text-danger mb-4 drop-shadow-[0_0_10px_rgba(239,68,68,0.5)]"></i>
      <p class="text-text-primary font-medium text-lg">{{ 'projects.list.error' | translate }}</p>
      <button
        (click)="retrySearch()"
        class="mt-6 btn-danger"
      >
        {{ 'projects.list.retry' | translate }}
      </button>
    </div>
  </div>

  <div
    *ngIf="!isLoading && !errorMessage && projects.length === 0"
    class="surface-elevated border border-border-strong rounded-2xl p-16 text-center relative overflow-hidden group"
  >
    <div class="absolute inset-0 bg-gradient-to-b from-primary-soft/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
    <div class="relative z-10">
      <div class="w-20 h-20 mx-auto bg-surface border border-border rounded-2xl flex items-center justify-center mb-6 shadow-subtle group-hover:border-primary/30 transition-colors duration-300">
        <i class="fas fa-building text-border-strong text-4xl group-hover:text-primary-soft transition-colors duration-300"></i>
      </div>
      <h3 class="h3 mb-2">{{ 'projects.list.noProjects' | translate }}</h3>
      <p class="body-large">{{ 'projects.list.noProjectsMessage' | translate }}</p>
    </div>
  </div>

  <div
    *ngIf="!isLoading && !errorMessage && projects.length > 0"
    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
  >
    <app-projects-card
      *ngFor="let project of projects"
      [project]="project"
      (projectClick)="onProjectClick($event)"
    ></app-projects-card>
  </div>
</div>
